import { persistReducer } from 'redux-persist';
import storageSessionModule from 'redux-persist/lib/storage/session';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// CJS(exports.default)라 Vite SSR external 번들에선 default가 안 풀린 네임스페이스로 들어온다. interop-safe 처리.
const storageSession = storageSessionModule.default ?? storageSessionModule;

export const encryptPersistReducer = ({ key, ...options }, reducer) =>
	persistReducer(
		{
			key,
			storage: storageSession,
			transforms: [
				encryptTransform({
					secretKey: key,
				}),
			],
			...options,
		},
		reducer,
	);

export default null;
